import { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import TabBar from '../components/layout/TabBar';
import { Boxes, BoxSelect, ClipboardList, ShoppingBag } from 'lucide-react';
import MaterialoveKarty from './MaterialoveKarty';
import BaliciPredpisy from '../components/balirna/BaliciPredpisy';

const SECTION_COLOR = '#10B981';
const SECTION_BG = 'rgba(16,185,129,0.12)';

/**
 * Balírna — všechno, co není jídlo, ale odchází s ním z kuchyně.
 *
 * Obaly se z Receptáře odstěhovaly sem, protože do receptu nepatří: ta samá
 * pizza jde v bistru na talíř a na rozvoz do krabice. Co přesně se použije,
 * říká balicí předpis podle kanálu — a ten se pak počítá jako packaging cost
 * vedle materiálu.
 *
 * Provozní materiál (úklid, baterky, párátka) je tu podnájemník. S balením
 * nemá společného nic, ale nakupuje se a odepisuje stejně; jeho domov je
 * budoucí Sklad.
 */
const ZALOZKY = [
    { id: 'obaly',     label: 'Obaly',            Icon: BoxSelect },
    { id: 'predpisy',  label: 'Balicí předpisy',  Icon: ClipboardList },
    { id: 'spotrebni', label: 'Provozní materiál', Icon: ShoppingBag },
];

export default function Balirna({ user, onNavigate, initialPolozka = null, initialDodavatelId = null }) {
    const { theme } = useTheme();
    const isDark = theme === 'dark' ||
        (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const secondaryColor = isDark ? 'rgba(255,255,255,0.5)' : 'var(--text-secondary)';
    const mutedColor = isDark ? 'rgba(255,255,255,0.35)' : 'var(--text-muted)';

    const ZALOZKA_PRO_TYP = { OBA: 'obaly', SPOZ: 'spotrebni' };
    // Záložky kreslí TabBar z katalogu. Výchozí je ta, na kterou míří proklik
    // z jiného modulu; když na ni uživatel nemá přístup, TabBar dosadí první
    // dostupnou sám.
    const [tab, setTab] = useState(() => ZALOZKA_PRO_TYP[initialPolozka?.typ] ?? null);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            {!isMobile && (
                <div className="flex items-center gap-3 mb-4" style={{ flexShrink: 0 }}>
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: SECTION_BG }}>
                        <Boxes size={20} style={{ color: SECTION_COLOR }} />
                    </div>
                    <div className="min-w-0">
                        <h1 className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>Balírna</h1>
                        <p className="text-xs" style={{ color: secondaryColor }}>
                            Obaly, balicí předpisy podle kanálu a provozní materiál
                        </p>
                    </div>
                </div>
            )}

            <TabBar modul="balirna" user={user} aktivni={tab} onZmena={setTab}
                barva={SECTION_COLOR} isDark={isDark} isMobile={isMobile} />

            {/* Obaly i provozní materiál kreslí stejná karta materiálu jako suroviny
                v Receptáři — je to jedna položka s cenami a jednotkami, ne tři. */}
            {tab !== 'predpisy' && (
                <div style={{ flex: 1, minHeight: 0 }}>
                    <MaterialoveKarty
                        vlozena tab={tab} onTab={setTab}
                        sekceBarva={SECTION_COLOR}
                        onNavigate={onNavigate}
                        initialPolozka={initialPolozka}
                        initialDodavatelId={initialDodavatelId}
                    />
                </div>
            )}

            {tab === 'predpisy' && (
                <div style={{ flex: 1, minHeight: 0 }}>
                    <BaliciPredpisy isDark={isDark} sekceBarva={SECTION_COLOR} onNavigate={onNavigate} />
                </div>
            )}

        </div>
    );
}
